export default {
  retrieveDayOffList (state, payload) {
    state.dayOffList = [].concat(payload.dayOffList)
  },

  deleteDayOff (state, payload) {
    state.dayOffList.splice(payload.index, 1)
    state.dayOffList = [].concat(state.dayOffList)
  },

  saveState (state, payload) {
    state.currentPage = payload.page ? payload.page : null
  }
}
